import AUTHAPI from './auth.api'

export default AUTHAPI
